import { render, staticRenderFns } from "./NewsletterContainer.vue?vue&type=template&id=4a64c221&scoped=true&"
import script from "./NewsletterContainer.vue?vue&type=script&lang=js&"
export * from "./NewsletterContainer.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterContainer.vue?vue&type=style&index=0&id=4a64c221&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a64c221",
  null
  
)

export default component.exports